import React, { ReactNode, useEffect, useState } from "react";
import { webViewContext } from "./webViewContext";

export interface WebViewProviderProps {
    children: ReactNode;
}

export const WebViewProvider = ({ children }: WebViewProviderProps): JSX.Element => {
    const WebViewContextProvider = webViewContext.Provider;
    const isWebViewFromStorage = sessionStorage.getItem("isWebView") === "true";
    const isRedirectToWelcomeScreenFromStorage = sessionStorage.getItem("fromWelcomeScreen") === "true";
    const isRedirectToRegIdentificationScreenFromStorage = sessionStorage.getItem("fromRegIdentification") === "true";
    const [isWebView, setIsWebView] = useState<boolean | undefined>(isWebViewFromStorage);
    const [isRedirectToWelcomeScreen, setIsRedirectToWelcomeScreen] = useState<boolean | undefined>(isRedirectToWelcomeScreenFromStorage);
    const [isRedirectToRegIdentificationScreen, setIsRedirectToRegIdentificationScreen] = useState<boolean | undefined>(isRedirectToRegIdentificationScreenFromStorage);

    useEffect(() => {
        const isWebView = window.location.search.includes("isWebView");
        const isRedirectToWelcomeScreen = window.location.search.includes("fromWelcomeScreen");
        const isRedirectToRegIdentificationScreen = window.location.search.includes("fromRegIdentification");
        if (isWebView) {
            sessionStorage.setItem("isWebView", "true");
        }
        if (isRedirectToWelcomeScreen) {
            sessionStorage.setItem("fromWelcomeScreen", "true");
        }
        if (isRedirectToRegIdentificationScreen) {
            sessionStorage.setItem("fromRegIdentification", "true");
        }
        setIsWebView(isWebView || isWebViewFromStorage);
        setIsRedirectToWelcomeScreen(isRedirectToWelcomeScreen || isRedirectToWelcomeScreenFromStorage)
        setIsRedirectToRegIdentificationScreen(isRedirectToRegIdentificationScreen || isRedirectToRegIdentificationScreenFromStorage)
    }, []);

    return (
        <WebViewContextProvider
            value={{
                isWebView,
                setIsWebView,
                isRedirectToWelcomeScreen,
                setIsRedirectToWelcomeScreen,
                isRedirectToRegIdentificationScreen,
                setIsRedirectToRegIdentificationScreen
            }}
        >
            {isWebView === undefined ? <></> : <>{children}</>}
        </WebViewContextProvider>
    );
};
